import { Skeleton } from '@web/components/ui/skeleton';

export default function UpdateContactDialogFormSkeleton() {
  return (
    <div className="flex h-full flex-col pb-6">
      <div className="flex flex-grow flex-col gap-5">
        <Skeleton className="h-8 w-full rounded-sm" />
        <Skeleton className="h-6 w-3/4 rounded-sm" />
        <Skeleton className="h-8 w-4/5 rounded-sm" />
        <Skeleton className="h-7 w-full rounded-sm" />
        <Skeleton className="h-8 w-full rounded-sm" />
        <Skeleton className="h-6 w-3/4 rounded-sm" />
        <Skeleton className="h-8 w-4/5 rounded-sm" />
        <Skeleton className="h-7 w-full rounded-sm" />
      </div>
      <div className="flex items-center justify-end gap-4">
        <Skeleton className="h-10 w-16" />
        <Skeleton className="h-10 w-20" />
      </div>
    </div>
  );
}
